module.exports = {
      id: "pix-usage",
      viewBox: "0 0 210 77",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#pix",
      toString: function () {
        return this.url;
      }
    }